import { useForm, useWatch } from "react-hook-form";

import Button, { ButtonTypes } from "../Button";
import { FormMoneyInput, FormPercentageInput } from "../Input";
import { onEnter } from "../../utils/keyboard";
import { grossAndTaxOf } from "../../utils/taxWithheld";
import {
  HelperActions,
  HelperField,
  HelperFields,
  HelperLabel,
} from "./styles";
import { NetToGrossFieldsProps, NetToGrossValues } from "./types";

const DEFAULT_TAX_RATE_PERCENT = 28;

export const NetToGrossFields = ({
  id,
  disabled,
  onApply,
}: NetToGrossFieldsProps) => {
  const netId = `${id}-net`;
  const rateId = `${id}-rate`;
  const { control } = useForm<NetToGrossValues>({
    defaultValues: { netAmount: "", taxRate: DEFAULT_TAX_RATE_PERCENT },
  });
  const [netAmount, taxRate] = useWatch({
    control,
    name: ["netAmount", "taxRate"],
  });
  const derived = grossAndTaxOf(netAmount, taxRate);
  const isApplyDisabled = disabled || !derived;

  const apply = () => {
    if (derived) {
      onApply(derived);
    }
  };

  // Enter in a helper input would otherwise submit the surrounding earnings form.
  const applyOnEnter = onEnter(apply);

  return (
    <HelperFields
      id={id}
      role="group"
      aria-label="Work out gross from net"
      onKeyDown={applyOnEnter}
    >
      <HelperField>
        <HelperLabel htmlFor={netId}>Net received</HelperLabel>
        <FormMoneyInput
          id={netId}
          name="netAmount"
          control={control}
          disabled={disabled}
          placeholder="Enter Net"
          autoFocus={true}
        />
      </HelperField>
      <HelperField>
        <HelperLabel htmlFor={rateId}>Tax rate (%)</HelperLabel>
        <FormPercentageInput
          id={rateId}
          name="taxRate"
          control={control}
          disabled={disabled}
          placeholder="Enter Rate"
        />
      </HelperField>
      <HelperActions>
        <Button
          type={ButtonTypes.secondary}
          size="small"
          disabled={isApplyDisabled}
          onClick={apply}
        >
          Apply
        </Button>
      </HelperActions>
    </HelperFields>
  );
};
